/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { relevantContactResponseDtoSchema } from "../relevantContactResponseDtoSchema";
import { z } from "zod/v4";

export const getRelevantContactsListQueryParamsSchema = z.object({
    "limit": z.optional(z.coerce.number().describe("Max contacts to return (1-10, default 5)"))
    }).optional()

export const getRelevantContactsListHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Top relevant contacts ranked by recent lead activity
 */
export const getRelevantContactsList200Schema = z.array(z.lazy(() => relevantContactResponseDtoSchema))

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const getRelevantContactsList401Schema = z.any()

export const getRelevantContactsListQueryResponseSchema = z.lazy(() => getRelevantContactsList200Schema)